
export const Routes = {
    Default: {
        path: "/"
    },
    DeleteAccount :{
        path:'/delete-account'
    },
    TermsAndConditions:{
        path : '/terms-and-condition'
    },
    PrivacyPolicy:{
        path : '/privacy-policy'
    },
    Faqs:{
        path:'/faqs'
    },
    Contact:{
        path:'/contact-us'
    }

}